import { render, staticRenderFns } from "./defaultTemp.vue?vue&type=template&id=6950ee9d&scoped=true"
import script from "./defaultTemp.vue?vue&type=script&lang=js"
export * from "./defaultTemp.vue?vue&type=script&lang=js"
import style0 from "./defaultTemp.vue?vue&type=style&index=0&id=6950ee9d&prod&lang=scss"
import style1 from "./defaultTemp.vue?vue&type=style&index=1&id=6950ee9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950ee9d",
  null
  
)

export default component.exports